module.exports = __webpack_public_path__ + "static/media/swimming-pool.49223ee3.png";